<template>
    <div >
        <vue-scroll :ops="$ops">
        <div style="height: 700px">
            <el-form :model="$parentInfo.Dialog_UpdateClassPackage.classPackage"
                     label-width="90px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="套餐名">
                            <el-input v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.name"
                                      placeholder="请输入套餐名"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="类型">
                            <el-select v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.type"
                                       remote
                                       clearable
                                       placeholder="请选择类型"
                                       class="inputWidth">
                                <el-option
                                        v-for="item in $parentInfo.types"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总介绍">
                            <el-input v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.remark"
                                      placeholder="请输入总介绍"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="适合对象">
                            <el-input v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.suitable_for_student"
                                      placeholder="请输入适合对象"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="问题呈现">
                            <el-input v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.problemPresented"
                                      placeholder="请输入问题呈现"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="解决方案">
                            <el-input v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.solution"
                                      placeholder="请输入解决方案"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="课程安排">
                            <el-input v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.curriculum"
                                      placeholder="请输入课程安排"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="班主任">
                            <el-input v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.headTeacher_name"
                                      placeholder="请输入班主任"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="班主任电话">
                            <el-input v-model="$parentInfo.Dialog_UpdateClassPackage.classPackage.headTeacher_phone"
                                      placeholder="请输入班主任电话"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-for="(classPackageFeature,index) in $parentInfo.Dialog_UpdateClassPackage.classPackage.classPackageFeatures" :key="index">
                        <el-row :gutter="20">
                            <el-col :span="10">
                                <el-form-item label="课程特色">
                                    <el-input v-model="classPackageFeature.name"
                                              placeholder="请输入课程特色"
                                              ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-upload
                                        class="upload-demo"
                                        :action="action"
                                        :on-preview="handlePreview"
                                        :on-remove="handleRemove"
                                        :file-list="$parentInfo.Dialog_UpdateClassPackage.fileList"
                                        :limit="0">
                                    <el-button size="small" type="primary" @click="uploadPhoto(classPackageFeature.id)">本地上传</el-button>
                                </el-upload>
                            </el-col>
                            <el-col :span="4">
                                <el-button type="primary" @click="handleDelFeature(classPackageFeature)" >删除</el-button>
                            </el-col>
                            <el-col :span="4">
                                <div style="height:30px;width:30px;display: flex; justify-content:center;align-items: center;">
                                    <div v-if="classPackageFeature.photo_url">
                                        <el-popover
                                                placement="right"
                                                trigger="click">
                                            <img :src="classPackageFeature.photo_url" style="width: 500px;height: 500px">
                                            <div slot="reference" @click="" style="width: 50px;height: 50px">
                                                <img :src="classPackageFeature.photo_url" alt=""
                                                     style="width: 50px;height: 50px">
                                            </div>
                                        </el-popover>
                                    </div>
                                    <div v-else>
                                        无
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <div style="text-align: right">
                        <el-button type="primary" @click="handleAddFeature()">新增特色</el-button>
                    </div>
                </el-row>

                <div class="m-separator m-separator--space m-separator--dashed"></div>
                <div v-for="(item,index) in $parentInfo.Dialog_UpdateClassPackage.classPackage.classPackageDetails" :key="index">
                    <div style="display: flex;flex-direction: row;justify-content:space-between;align-items:center">
                        <div>
                            <div>
                                {{item.name}}
                            </div>
                            <div>
                                {{item.semester_and_date}}
                            </div>
                        </div>
                        <div>
                            {{item.sum_price|currency('￥')}}
                        </div>
                        <div>
                            <el-button type="primary" @click="handleDeleteClassPackageDetail(item.id)">删除
                            </el-button>
                        </div>
                    </div>

                    <div class="m-separator m-separator--space m-separator--dashed"></div>
                </div>
            </el-form>
        </div>
        </vue-scroll>
        <div class=" text-right">
            <el-button type="primary" @click="handleUpdateClassPackage"
                       :loading="$parentInfo.Dialog_UpdateClassPackage.button_loading">保 存
            </el-button>
        </div>

    </div>

</template>

<script>
    export default {
        name: 'Dialog_UpdateClassPackage',
        data() {
            return {
                show:false,
                class_package_feature_id:0
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetClassPackage();
        },
        computed: {
            action(){
                return "https://server.modijiaoyu.com/classPackage/features?class_package_feature_id="+this.class_package_feature_id
            },
            powers() {
                return this.$store.state.config.powers;
            },
        },
        methods: {
            handleGetClassPackage(){
                this.$wApi.send(this.$parentInfo.path, 'get_classPackage', {
                    classPackage_id:this.$store.state.modal.data.classPackage_id
                });
            },
            handleUpdateClassPackage() {
                this.$parentInfo.Dialog_UpdateClassPackage.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'update_classPackage', {
                    classPackage_id:this.$store.state.modal.data.classPackage_id,
                    name:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.name,
                    suitable_for_student:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.suitable_for_student,
                    remark:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.remark,
                    class_features:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.class_features,
                    curriculum:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.curriculum,
                    problemPresented:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.problemPresented,
                    solution:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.solution,
                    headTeacher_name:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.headTeacher_name,
                    headTeacher_phone:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.headTeacher_phone,
                    type:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.type,
                    classPackageFeatures:this.$parentInfo.Dialog_UpdateClassPackage.classPackage.classPackageFeatures
                });
            },
            handleDeleteClassPackageDetail(classPackage_detail_id){
                this.$confirm('确定删除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'remove_class_from_classPackage', {
                        'classPackage_detail_id': classPackage_detail_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleRemove(file, fileList) {

            },
            handlePreview(file) {
                console.log(file);
            },
            handleDelFeature(classPackageFeature){
                this.$wApi.send(this.$parentInfo.path, 'delete_classPackage_features', {
                    class_package_features_id:classPackageFeature.id,
                });
            },
            handleAddFeature(){
                this.$wApi.send(this.$parentInfo.path, 'add_classPackage_features', {
                    classPackage_id:this.$store.state.modal.data.classPackage_id,
                });
            },
            uploadPhoto(class_package_feature_id){
                this.class_package_feature_id=class_package_feature_id
            }
        }
    }
</script>

<style scoped lang="scss">
    .card-body {
        height: calc(100vh - 125px);
    }

    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }

    .inputWidth {
        width: 250px !important;
    }
</style>
